import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  baseUrl = environment.apiUrl;

constructor(private http: HttpClient) { }

  // assigns this user with the email to a role
  userPermission(model: any) {
    let tokenString = '';
      const securityToken: string = localStorage.getItem('token');
      let httpHeaders = new HttpHeaders();
      if (securityToken != null) {
        tokenString = `Bearer ${securityToken}`;
        httpHeaders = new HttpHeaders()
          .set('authorization', tokenString)
          .set('Content-Type', 'application/json');
      } else {
        httpHeaders = new HttpHeaders()
          .set('Content-Type', 'application/json');
      }
    return this.http.post(this.baseUrl + `userrole/assign` , model, {headers: httpHeaders, observe: 'response'});
  }

  // this populates the drop down 
  getRoles() {
    let tokenString = '';
      const securityToken: string = localStorage.getItem('token');
      let httpHeaders = new HttpHeaders();
      if (securityToken != null) {
        tokenString = `Bearer ${securityToken}`;
        httpHeaders = new HttpHeaders()
          .set('authorization', tokenString)
          .set('Content-Type', 'application/json');
      } else {
        httpHeaders = new HttpHeaders()
          .set('Content-Type', 'application/json');
      }
    return this.http.get(this.baseUrl + `role/roles`, {headers: httpHeaders});
  }
}